import useDeleteGrupoUnidade from "features/grupo-unidades/hooks/useDeleteGrupoUnidade";
import useGruposUnidades from "features/grupo-unidades/hooks/useGruposUnidades";
import { GrupoUnidadeItem } from "features/grupo-unidades/typings";
import { showErrorAxios } from "infra/helpers/alerta";
import history from "infra/helpers/history";
import { useEffect, useState } from "react";
import ModalGrupoUnidade from "ui/components/Input/SelectGrupoUnidade/ModalGrupoUnidade";
import NewTable from "components/NewTable";
import PageHeader from "components/Page/PageHeader";
import HeaderTable from "./components/HeaderTable";
import useGrupoUnidadesColumns from "./hooks/useGrupoUnidadesColumns";
import { showConfirm } from "infra/helpers/alerta";
import { PermissaoEnum } from "resources/enums/permissao";

function GrupoUnidades() {
  const [editGrupoUnidade, setEditGrupoUnidade] = useState<
    GrupoUnidadeItem | undefined
  >();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { data, isLoading, isFetching, refetch } = useGruposUnidades();
  const { mutate: deleteGrupoUnidade, isLoading: loadingDelete } =
    useDeleteGrupoUnidade();
  const [searchValue, setSearchValue] = useState("");

  const columns = useGrupoUnidadesColumns();

  const _isLoading = isLoading || isFetching || loadingDelete;

  const onSearch = (v?: string) => setSearchValue(v || "");

  const _data =
    data?.filter((item) =>
      item.nome.toLowerCase().includes(searchValue.toLowerCase())
    ) ?? [];

  useEffect(() => {
    if (editGrupoUnidade) {
      setIsOpenModal(true);
    }
  }, [editGrupoUnidade]);

  useEffect(() => {
    if (!isOpenModal) {
      setEditGrupoUnidade(undefined);
    }
  }, [isOpenModal]);

  return (
    <>
      <PageHeader
        title="Grupo de unidades"
        titleButton="Criar novo grupo"
        permissions={PermissaoEnum.Backoffice.Administrativo.GrupoUnidade.Criar}
        onClick={() => setIsOpenModal(true)}
      />

      <NewTable<GrupoUnidadeItem>
        title={() => <HeaderTable value={searchValue} onSearch={onSearch} />}
        loading={_isLoading}
        columns={columns}
        dataSource={_data}
        actions={[
          {
            title: "Ver grupo",
            onClick: (v: GrupoUnidadeItem) => {
              history.push(`/cadastros/grupos-unidades/${v.id}`, {
                nome: v.nome,
              });
            },
          },
          {
            title: "Editar",
            onClick: (v: GrupoUnidadeItem) => {
              setEditGrupoUnidade(v);
            },
          },

          {
            title: "Excluir",
            onClick: (v: GrupoUnidadeItem) => {
              showConfirm("Deseja realmente excluir esse grupo?").then(
                ({ isConfirmed }) => {
                  if (isConfirmed) {
                    deleteGrupoUnidade(v.id, {
                      onSuccess: () => refetch(),
                      onError: (e) => {
                        showErrorAxios(e);
                      },
                    });
                  }
                }
              );
            },
          },
        ]}
      />

      <ModalGrupoUnidade
        visible={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        editId={editGrupoUnidade?.id}
        defaultValue={{ nome: editGrupoUnidade?.nome || "" }}
        onSuccess={() => refetch()}
        showCadastroUnidades={!editGrupoUnidade}
      />
    </>
  );
}

export default GrupoUnidades;
